export const GymDetailsHeaderRoutes = {
  dashboard: 0,
  members: 1,
  gymAccessCategories: 2,
  zones: 3,
  accesspoints: 4,
  gymSchedules: 5
};

export type GymDetailsHeaderTabNames = keyof typeof GymDetailsHeaderRoutes;
